export default __webpack_public_path__ + "static/media/piny-logo-white.b9894841.png";